import axios from "axios";
import VueCookies from 'vue-cookies'
import * as qs from "qs";
import {checkToken, throttleRefreshToken, redirectLogin} from "@/network/sso";

// 添加401计数器
let unauthorizedCount = 0;
// 最大尝试次数
const MAX_UNAUTHORIZED_ATTEMPTS = 5;
// 计数器重置定时器
let resetTimer = null;

export const url = {
  baseUrl: window.g.gatewayUrl
};

export const serviceUrl = {
  activitiService:'/activiti-service',
  deviceService: '/device-service',
  extensionService: '/extension-service',
  iamService: '/iam-service',
  spaceService: '/space-service',
  cameraService: '/camera-service',
  ssoService: '/sso-service',
  notificationService: '/notification-service',
  iotboxService:'/iotbox-service',
  emsService: '/ems-service'
}

export function request(config) {
  const instance = axios.create({
    baseURL: url.baseUrl,
    timeout: 60000
  })

  // 2.axios拦截器
  // 2.1请求拦截
  instance.interceptors.request.use(config => {
    if (config.method === 'get') {
      // 如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2,不转换会显示为arr[]=1&arr[]=2
      config.paramsSerializer = function (params) {
        return qs.stringify(params, {arrayFormat: 'repeat'})
      }
    }

    config.headers['Authorization'] = 'Bearer ' + VueCookies.get('token')
    return config
  }, err => {
    console.log('requestErr', err);
    return err
  })
  // 2.2响应拦截
  instance.interceptors.response.use(res => {
    // 成功响应时重置计数器
    unauthorizedCount = 0;
    if (resetTimer) {
      clearTimeout(resetTimer);
      resetTimer = null;
    }

    if (res.data && res.data.data) {
      //响应的数据
      let resDataStr = JSON.stringify(res.data.data);
      //当前的网段
      let netSegment = window.g.domain.slice(0, window.g.domain.lastIndexOf('.'));
      //如果包含http和当前网段的,则将ip替换为当前网站的ip
      if (netSegment != null
        && resDataStr.indexOf('http') !== -1
        && resDataStr.indexOf('image') !== -1
        && resDataStr.indexOf(netSegment)) {
        //替换ip
        resDataStr = resDataStr.replaceAll('192.168.1.240', window.g.domain);
        res.data.data = JSON.parse(resDataStr);
      }
    }
    return res.data
  }, err => {
    console.log('responseErr', err);
    if (undefined !== err.response) {
      if (err.response.config.url.includes("check-token") || err.response.config.url.includes("refresh-token")) {
        return err;
      }
      switch (err.response.status) {
        case 401:
          // 增加401计数
          unauthorizedCount++;
          console.log(`401错误计数: ${unauthorizedCount}/${MAX_UNAUTHORIZED_ATTEMPTS}`);
          console.log( 'token'+VueCookies.get('token')+ '---refreshToken=' + VueCookies.get('refreshToken'));
          
          // 如果达到最大尝试次数，则重定向到登录页
          if (unauthorizedCount >= MAX_UNAUTHORIZED_ATTEMPTS) {
            console.log('达到最大尝试次数，退出登录');
            unauthorizedCount = 0; // 重置计数器
            redirectLogin(); // 重定向到登录页
          } else {
            // 尝试刷新token
            throttleRefreshToken();
            
            // 设置30秒后重置计数器
            if (resetTimer) {
              clearTimeout(resetTimer);
            }
            resetTimer = setTimeout(() => {
              console.log('重置401错误计数器');
              unauthorizedCount = 0;
              resetTimer = null;
            }, 30000); // 30秒后重置
          }
          break
        case 500:
          checkToken()
          break
        default:
      }
    }
    return err
  })

  // 3.发送真正的网络请求
  return instance(config)
}
